import React, { Component } from "react";

import styles from "./style.module.css";
import Logo from "../../../assets/images/login/logo-white.svg";

import api from "../../../services/api";

import Input from "../../../components/Input";
import ButtonLoading from "../../../components/Buttons/ButtonLoading";
import Modal from "../../../components/Modal";

import { API_GUARD } from "../../../services/env";

export default class PasswordRecovery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: true,
      register: false,
      email: "",
      password: "",
      passwordConfirm: "",
      isLoading: false,
      isAlertOn: false,
      forgotModal: false,
      validate: {
        email: {
          message: "",
          isInvalid: false
        },
        password: {
          message: "",
          isInvalid: false
        }
      },
      alertMessage: {
        title: "",
        message: ""
      }
    };
  }

  toggleIsLoad(boolean) {
    this.setState({ isLoading: boolean });
  }

  toggleAlert() {
    this.setState({
      isAlertOn: !this.state.isAlertOn
    });
  }

  openLogin(history) {
    history.push("/");
  }

  openRegister(history) {
    history.push("/auth/cadastrar");
  }

  activeAlert(alertMessage) {
    const { title, message } = alertMessage;
    this.setState({
      ...this.state,
      isAlertOn: true,
      alertMessage: {
        title,
        message
      }
    });
  }

  handlerChangeInput(value) {
    const key = Object.keys(value)[0];
    this.setState({
      ...value,
      validate: {
        ...this.state.validate,
        [key]: {
          message: "",
          isInvalid: false
        }
      }
    });
  }

  async handlerPasswordRecovery(event) {
    event.preventDefault();
    if (!this.state.isLoading) {
      this.toggleIsLoad(true);
      const { token } = this.props.match.params;
      const { email, password, passwordConfirm } = this.state;
      try {
        const response = await api.post(
          `/v1/${API_GUARD}/auth/password/reset`,
          { email, password, passwordConfirm, token }
        );
        if (response.status && response.status === 200) {
          const alertMessage = {
            title: "Sucesso!",
            message: "Sua senha foi alterada com sucesso!"
          };
          this.activeAlert(alertMessage);
        }
        this.toggleIsLoad(false);
      } catch (error) {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              const alertMessage = {
                title: "Ops... algo deu errado!",
                message: "Não foi possivel recuperar sua senha."
              };
              this.activeAlert(alertMessage);
              break;
            case 422:
              const { errors } = error.response.data;
              for (let key in errors) {
                this.setState({
                  validate: {
                    ...this.state.validate,
                    [key]: {
                      message: errors[key],
                      isInvalid: true
                    }
                  }
                });
              }
              break;
            default:
              console.warn("Ops... algo de errado aconteceu!");
          }
        }
        this.toggleIsLoad(false);
      }
    }
  }

  render() {
    // 
    const { history } = this.props;
    return (
      <>
        <div className={styles.login}>
          <div className={styles.container}>
            <div className={styles.header}></div>
            <div className={styles.body}>
              <div className={styles.card}>
                <div className={styles.cardLeftSide}>
                  <img src={Logo} alt="Flex IP" className={styles.logo} />
                  <h1 className={styles.title}>PABX Flexible Admin.</h1>
                  <ul className={styles.list}>
                    <li className={styles.listItem}>
                      <i className={"icon-magic-wand " + styles.icon}></i>Custo
                      ZERO entre Filiais
                    </li>
                    <li className={styles.listItem}>
                      <i className={"icon-layers " + styles.icon}></i>Relatórios
                      Detalhados
                    </li>
                    <li className={styles.listItem}>
                      <i
                        className={"icon-arrow-right-circle " + styles.icon}
                      ></i>
                      Fácil expansão
                    </li>
                    <li className={styles.listItem}>
                      <i className={"icon-drop " + styles.icon}></i>
                      Flexibilidade
                    </li>
                  </ul>
                </div>
                <div className={styles.mobileHeader}>
                  <img src={Logo} alt="Flex IP" className={styles.logo} />
                </div>
                <div className={styles.cardRightSide}>
                  <h2 className={styles.description}>
                    <strong>REDEFINIR</strong> SENHA
                  </h2>
                  <form
                    onSubmit={event => this.handlerPasswordRecovery(event)}
                    className={styles.form}
                  >
                    <Input
                      type="text"
                      name="email"
                      placeholder="E-mail"
                      icon="icon-envelope"
                      isInvalid={this.state.validate.email.isInvalid}
                      invalidMessage={this.state.validate.email.message}
                      onChange={event =>
                        this.handlerChangeInput({ email: event.target.value })
                      }
                    />
                    <Input
                      type="password"
                      name="password"
                      placeholder="Senha"
                      icon="icon-lock"
                      isInvalid={this.state.validate.password.isInvalid}
                      invalidMessage={this.state.validate.password.message}
                      onChange={event =>
                        this.handlerChangeInput({
                          password: event.target.value
                        })
                      }
                    />
                    <Input
                      type="password"
                      name="password-confirm"
                      placeholder="Confirmar senha"
                      icon="icon-reload"
                      isInvalid={this.state.validate.password.isInvalid}
                      invalidMessage={this.state.validate.password.message}
                      onChange={event =>
                        this.handlerChangeInput({
                          passwordConfirm: event.target.value
                        })
                      }
                    />
                    <ButtonLoading
                      isLoading={this.state.isLoading}
                      text="Confirmar"
                    />
                  </form>
                </div>
              </div>
              <div className={styles.radius}>
                <div
                  className={styles.radiusLeft}
                  onClick={() => {
                    this.openRegister(history);
                  }}
                >
                  <p className={styles.radiusItem}>Cadastrar sua empresa</p>
                </div>
                <div
                  className={styles.radiusRight}
                  onClick={() => {
                    this.openLogin(history);
                  }}
                >
                  <p className={styles.radiusItem}>Fazer login</p>
                </div>
              </div>
            </div>

            <footer className={styles.footer}>
              <p className={styles.footerText}>
                Copyright © 2020 Flex IP Admin. Todos os direitos reservados.
              </p>
            </footer>
          </div>
        </div>
        <Modal
          isActive={this.state.isAlertOn}
          toggleAlert={() => {
            this.toggleAlert();
            this.props.history.push("/");
          }}
          title={this.state.alertMessage.title}
          text={this.state.alertMessage.message}
        />
      </>
    );
  }
}
